import React from "react"
import BottomBar from "../BottomBar/bottombar"
import { useHistory } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "store/store"
import { apiEndPoints } from "constants/apiEndpoints"
import { useState, useEffect } from "react"
import { Modal } from "@fourkites/elemental-modal"
import { InfoAlert } from "../../images"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import axios from "axios"
import "./EventTracking.css"
import { useTranslation } from "react-i18next"

export let apiData: any

function EventTracking() {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [eventData, setEventData]: any = useState()
  const [radioBtnVal, setRadioBtnVal] = useState("")
  const [inpVal1, setInpVal1] = useState("")
  const [inpVal2, setInpVal2] = useState("")
  const [isSelected, setIsSelected] = useState(false)
  const [disabledProceedET, setDisabledProceedET] = useState(true)
  const [isOpen, setIsOpen] = useState(false)
  const [isReadonly, setIsReadonly] = useState(true)
  const [addClass, setAddclass] = useState("label-text-hrs")
  const [isSubmitted, setIsSubmitted] = useState(false)

  const assetReducer = useSelector((state: RootState) => state.assetReducer)
  const facilityId = useSelector(
    (state: RootState) => state.facilityReducer.facility?.id || ""
  )
  const rgx = /^[0-9]{0,2}$/
  let errEle = document.getElementById("error") as HTMLElement
  const errInfo = {
    splCharacter: t("no_special_characters_allowed"),
    valComparer: t("value_should_greater_than", { value: inpVal1 }),
    lessValue: t("value_should_be_greater_than_or_equal_to_2_hours")
  }

  const setEventTrack = () => {
    setIsSubmitted(true)
    if (parseInt(inpVal1) < 2 || parseInt(inpVal2) < 2) {
      setDisabledProceedET(true)
      errEle.innerHTML = errInfo.lessValue
      return
    }

    if (parseInt(inpVal1) >= parseInt(inpVal2)) {
      setDisabledProceedET(true)
      errEle.innerHTML = errInfo.valComparer
      return
    }

    let asset = {
      ...assetReducer.asset,
      estimatedCheckout: radioBtnVal
    }

    dispatch({
      type: "SET_ASSET_INFO",
      payload: asset
    })

    if (parseInt(inpVal1) >= 4 || parseInt(inpVal2) >= 4) {
      setIsOpen(true)
      return
    }

    history.push("/break-tracking")
  }

  useEffect(() => {
    axios
      .get(`${apiEndPoints.facilities}/${facilityId}/fields?action=gatelink`)
      .then(response => {
        apiData = response.data
        setEventData(apiData)
      })
  }, [])

  useEffect(() => {
    if (inpVal1 !== "" && inpVal2 !== "") {
      setDisabledProceedET(false)
      setIsSubmitted(false)
      let customValue1 =
        parseInt(inpVal1) < 10 ? "0" + parseInt(inpVal1) : inpVal1
      let customValue2 =
        parseInt(inpVal2) < 10 ? "0" + parseInt(inpVal2) : inpVal2
      let customValue = customValue1 + " to " + customValue2
      setRadioBtnVal(customValue)
    } else if (inpVal1 === "" || inpVal2 === "") {
      setIsSubmitted(false)
      setDisabledProceedET(true)
    }
    if (isSelected) {
      setDisabledProceedET(false)
    }
  }, [radioBtnVal, inpVal1, inpVal2])

  const changeHandler1 = (e: any) => {
    errEle.innerHTML = ""
    let val = e
    if (!rgx.test(val)) {
      return
    }

    setInpVal1(val)
  }
  const changeHandler2 = (e: any) => {
    errEle.innerHTML = ""
    let val = e
    if (!rgx.test(val)) {
      return
    }

    setInpVal2(val)
  }

  const onRadioBtnChange = (e: any) => {
    let radioBtnsVal
    if (
      e.target.checked &&
      e.target.defaultValue !== "Other (Please specify):"
    ) {
      radioBtnsVal = e.target.value
      if (errEle) {
        errEle.innerHTML = ""
      }
      setIsSelected(true)
      setIsReadonly(true)
      setInpVal1("")
      setInpVal2("")
      setAddclass("label-text-hrs")
    } else {
      setIsSelected(false)
      setIsReadonly(false)
      setAddclass("")
    }
    setRadioBtnVal(radioBtnsVal)
  }

  const onDlgClose = () => {
    setIsOpen(false)
  }

  const onModalConfirm = () => {
    history.push("/break-tracking")
  }

  return (
    <>
      <div className="radio-group-container">
        {eventData && (
          <div className="radio-group-header">
            {t(eventData?.data?.gatelink[0].title)}
          </div>
        )}
        <div className="radio-group-wrapper">
          <form className="mainForm">
            <div className="radio-group">
              {eventData?.data?.gatelink[0]?.options.map(
                (options: any, index: any) => {
                  return (
                    <label key={index}>
                      <input
                        type="radio"
                        name="TimeTracking"
                        value={options.name}
                        onChange={e => onRadioBtnChange(e)}
                      />
                      {t(options.name)}
                    </label>
                  )
                }
              )}
            </div>
            {eventData && (
              <div className="number-input">
                <label>{t("to")}</label>&nbsp;
                <input
                  className={
                    parseInt(inpVal1) < 2 && isSubmitted ? "hr-input" : ""
                  }
                  type="tel"
                  placeholder="HH"
                  maxLength={2}
                  readOnly={isReadonly}
                  value={inpVal1}
                  onChange={e => {
                    changeHandler1(e.target.value)
                  }}
                />
                &nbsp;&nbsp;
                <label id="hr1" className={`${addClass}`}>
                  {t("hrs")}
                </label>
                &nbsp;&nbsp;
                <label>{t("to")}</label>&nbsp;
                <input
                  className={
                    parseInt(inpVal1) >= parseInt(inpVal2) && isSubmitted
                      ? "hr-input"
                      : ""
                  }
                  type="tel"
                  placeholder="HH"
                  maxLength={2}
                  readOnly={isReadonly}
                  value={inpVal2}
                  onChange={e => {
                    changeHandler2(e.target.value)
                  }}
                />
                &nbsp;&nbsp;
                <label id="hr2" className={`${addClass}`}>
                  {t("hrs")}
                </label>
                <p id="error"></p>
              </div>
            )}
          </form>
        </div>
        <Modal
          title=""
          customHeader={
            <div className="header-container">
              <span>
                <b>{t("alert")}</b>
              </span>
              <span className="close-icon" onClick={() => onDlgClose()}>
                X
              </span>
            </div>
          }
          show={isOpen}
          size="large"
          onSave={() => onModalConfirm()}
          saveLabel={t("i_confirm")}
        >
          <div className="modal-container">
            <img className="warning-img-ET" src={InfoAlert} alt="info" />
            <div>
              <p> {t("you_will_be_checking_out_text")}</p>
              <p className="time-text">
                <b>
                  {t("in_value1_to_value2_hours", {
                    value1: inpVal1,
                    value2: inpVal2
                  })}
                </b>
              </p>
              <p>{t("confirm_interval_time_interval_text")}</p>
            </div>
          </div>
        </Modal>
      </div>
      <BottomBar
        disabled={disabledProceedET}
        onClick={() => setEventTrack()}
        text={t("save_and_proceed")}
        endIcon={<KeyboardArrowRightIcon />}
      />
    </>
  )
}

export default EventTracking
